import { combineReducers } from 'redux';
import { headerReducer } from './header';

const appReducer = combineReducers({
  header: headerReducer
})

const rootReducer = (state, action) => {
  // if (action.type === LOGOUT) {
  //   state = undefined
  // }

  return appReducer(state, action)
}

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js